import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { adminAPI } from '../../../services/api';
import { FiClock, FiCheckCircle, FiAlertCircle, FiEye, FiCalendar, FiWatch } from 'react-icons/fi';
import './TestBlocksCheckingPage.css';

const TestBlocksCheckingPage = () => {
    const [results, setResults] = useState([]);
    const [loading, setLoading] = useState(true);
    const [filter, setFilter] = useState('pending'); // pending, checked, all
    const navigate = useNavigate();

    useEffect(() => {
        loadResults();
    }, [filter]);

    const loadResults = async () => {
        try {
            setLoading(true);
            const response = await adminAPI.getTestBlocksResults(filter);
            console.log('API response:', response); // Отладка
            const data = Array.isArray(response) ? response : (response.data || []);
            setResults(data);
        } catch (error) {
            console.error('Ошибка загрузки результатов:', error);
            setResults([]);
        } finally {
            setLoading(false);
        }
    };

    const formatDate = (dateString) => {
        const date = new Date(dateString);
        return date.toLocaleString('ru-RU', {
            day: '2-digit',
            month: '2-digit',
            year: 'numeric',
            hour: '2-digit',
            minute: '2-digit'
        });
    };

    const formatTime = (seconds) => {
        const mins = Math.floor(seconds / 60);
        const secs = seconds % 60;
        return `${mins}м ${secs}с`;
    };

    return (
        <div className="test-blocks-checking-page">
            <div className="test-blocks-checking-header">
                <h2>Проверка тестов</h2>
            </div>

            <div className="test-blocks-checking-filters">
                <button
                    onClick={() => setFilter('pending')}
                    className={`test-blocks-filter-btn pending ${filter === 'pending' ? 'active' : ''}`}
                >
                    <FiClock /> Ожидают проверки
                </button>
                <button
                    onClick={() => setFilter('checked')}
                    className={`test-blocks-filter-btn checked ${filter === 'checked' ? 'active' : ''}`}
                >
                    <FiCheckCircle /> Проверенные
                </button>
                <button
                    onClick={() => setFilter('all')}
                    className={`test-blocks-filter-btn all ${filter === 'all' ? 'active' : ''}`}
                >
                    Все
                </button>
            </div>

            {loading ? (
                <div className="test-blocks-loading">Загрузка...</div>
            ) : results.length === 0 ? (
                <div className="test-blocks-empty">
                    <FiAlertCircle size={48} style={{ marginBottom: '15px' }} />
                    <p>Нет результатов для проверки</p>
                </div>
            ) : (
                <div className="test-blocks-list">
                    {results.map(result => (
                        <div key={result.id} className="test-blocks-result-card">
                            <div className="test-blocks-result-info">
                                <div className="test-blocks-result-header">
                                    <h3>{result.student_name}</h3>
                                    <span className={`test-blocks-status-badge ${result.writing_checked ? 'checked' : 'pending'}`}>
                                        {result.writing_checked ? 'Проверено' : 'Ожидает проверки'}
                                    </span>
                                </div>

                                <div className="test-blocks-test-title">
                                    <strong>{result.test_title}</strong>
                                </div>

                                <div className="test-blocks-result-meta">
                                    <span>
                                        <FiCalendar size={14} /> {formatDate(result.completed_at)}
                                    </span>
                                    <span>
                                        <FiWatch size={14} /> {formatTime(result.time_spent)}
                                    </span>
                                    {result.writing_checked && result.final_score && (
                                        <span className="score-final">
                                            <FiCheckCircle size={14} /> Итоговый балл: {result.final_score}/{result.max_score} ({result.final_percentage}%)
                                        </span>
                                    )}
                                    {!result.writing_checked && (
                                        <span className="score-auto">
                                            Автоматическая оценка: {result.score}/{result.max_score} ({result.percentage}%)
                                        </span>
                                    )}
                                </div>
                            </div>

                            <button
                                onClick={() => navigate(`/admin/checking/test-blocks/${result.id}`)}
                                className="btn-test-blocks-check"
                            >
                                <FiEye /> {result.writing_checked ? 'Просмотреть' : 'Проверить'}
                            </button>
                        </div>
                    ))}
                </div>
            )}
        </div>
    );
};

export default TestBlocksCheckingPage;
